import { api } from './graphql';

api.enhanceEndpoints({
  endpoints: {
    GetAdminParentCompanies: { providesTags: ['ParentCompany'] },
    AddAdminParentCompany: { invalidatesTags: ['ParentCompany'] },
    UpdateAdminParentCompany: { invalidatesTags: ['ParentCompany'] },
    DeleteAdminParentCompany: { invalidatesTags: ['ParentCompany'] },
    AddAdminParentCompanyAdministrator: { invalidatesTags: ['ParentCompany'] },
    RemoveAdminParentCompanyAdministrator: { invalidatesTags: ['ParentCompany'] },
    // Tenant<->parent-company membership changes both sides: the parent company's tenant
    // count feeds its derived status, and the AdminTenants grid's Parent Company column
    // reads straight off AdminTenant, so both tags must invalidate together.
    SetAdminTenantParentCompany: { invalidatesTags: ['ParentCompany', 'AdminTenant'] },
  },
});
